<template>
  <div class="show-img">
    <el-image :src="pdfUrl" class="mini-img" v-if="isPdf">
      <span slot="error"><el-link :href="url" :underline="false" target="_blank" title="在新页面打开"></el-link></span>
    </el-image>
    <el-image :preview-src-list="[url]" :src="url" class="mini-img" title="点击放大" v-else>
      <span slot="error"><el-link :href="url" :underline="false" target="_blank" title="在新页面打开"></el-link></span>
    </el-image>
    <el-link :href="url" :underline="false" target="_blank" title="在新页面打开">查看</el-link>
  </div>
</template>

<script>
import { getFileUrl } from "@/http/upload.js"
import { getFile } from '@/http/api.js'
import pdfReplace from '@/assets/img/pdf.png';
export default {
  name: 'ShowImg',
  props: {
    id: String,
    isLogin: { // 是否登录
      type: Boolean,
      default: true
    },
    src: String,
  },
  data() {
    return {
      pdfUrl: pdfReplace,
      isPdf: false
    }
  },
  computed: {
    url() {
      return this.src || getFileUrl(this.id, this.isLogin) 
    }
  },
  methods: {
    handleFile() {
      if(this.id) {
        getFile(`/bds/publicrs/image/${ this.id }`).then(res => {
          this.fileType = res.type
          this.isPdf = res.type == 'application/pdf'
        })
      }
    },
  },
  async created() {
    await this.handleFile()
  }
}
</script>

<style lang="less" scoped>
.show-img {
  display: flex;
  align-items: center;
  .mini-img {
    width: 80px;
    height: 80px;
    background-size: contain;
    margin-right: 10px;
  }
  .el-link.el-link--default {
    color: #1b5bbf;
  }
}

</style>